import React from "react";
import { Grid, IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import TimeCalculator from "../../sharedCode/TimeCalculator";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import { TicketLocationExtended } from "../../Utils/TypeExtensions";
import { addLocation } from "../../Utils/TicketDatabase";

export default function DurationFooter(props: TicketProps): JSX.Element {
    const totalHours = TimeCalculator.getTotalFlightTimeFormatted(props.ticket);

    return (
        <Grid container flexDirection={"row"} sx={{ marginTop: 2 }}>
            <Grid item container xs={11}>
                <Grid item xs={2}>
                    <IconButton disabled={props.isReadOnly} size="large" color="inherit" onClick={handleAddClicked}>
                        <AddIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={8}>
                    <Typography sx={{ textAlign: "right" }}>TOTAL FLIGHT HOURS</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography sx={{ marginRight: 1.8, textAlign: "right" }}>{totalHours}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={1}></Grid>
        </Grid>
    );

    function handleAddClicked(): void {
        const id = props.ticket.nextLocalId;
        const sortOrder = props.ticket.Locations ? props.ticket.Locations.length : 0;
        const newLocation = {
            id: id,
            location: "",
            ticket_id: props.ticket.id,
            sort_order: sortOrder,
        } as TicketLocationExtended;

        addLocation(props.ticket.id, newLocation).catch(() => props.showForceReloadDialogue());
    }
}
